import { render, staticRenderFns } from "./AssetsControl.vue?vue&type=template&id=2a231e17&scoped=true&"
import script from "./AssetsControl.vue?vue&type=script&lang=js&"
export * from "./AssetsControl.vue?vue&type=script&lang=js&"
import style0 from "./AssetsControl.vue?vue&type=style&index=0&id=2a231e17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a231e17",
  null
  
)

export default component.exports